import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Button, Checkbox } from 'semantic-ui-react';
import { change } from 'redux-form';

import { Filter, Main } from 'Containers';
import ReactTable from 'Common/ReactTableWrapper';
import { NotificationMessage, YesNoDialog } from 'Components';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { IPRANGE_ENTRY_FORM_NAME } from 'Common/FormEnum';
import { IPRangeFieldEnum } from 'Common/FieldEnum';
import { errorToast } from 'Common/ToastHelper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';

import { IPRangeEntryModal } from './components/IPRangeEntryModal';
import { rangeString } from './helpers/NetworkFilteringHelpers';
import * as NetworkFilteringActions from './state/actions';
import * as NetworkFilteringSelectors from './state/selectors';

const humanName = 'IP Range';

class NetworkFilteringContainer extends Component {
  state = {
    rowData: undefined,
    isCreateModalOpen: false,
    isDeleteModalOpen: false,
    isEnableModalOpen: false,
    myIP: undefined,
  };

  menuOptions = [
    {
      icon: 'pencil',
      text: 'Edit',
      handler: rowData => this.openCreateModal(rowData),
      disabledWhen: x => this.props.isReadOnly,
    },
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: rowData => this.openDeleteModal(rowData),
      disabledWhen: x => this.props.isReadOnly,
    },
  ];

  columns = [
    {
      Header: 'Description',
      accessor: IPRangeFieldEnum.Description,
      filterable: false,
      resizable: false,
    },
    {
      Header: 'Range Start',
      accessor: IPRangeFieldEnum.LowerRange,
      filterable: false,
      resizable: false,
    },
    {
      Header: 'Range End',
      accessor: IPRangeFieldEnum.UpperRange,
      filterable: false,
      resizable: false,
    },
    {
      Header: '',
      id: 'menu',
      width: 50,
      sortable: false,
      resizable: false,
      style: { textAlign: 'center' },
      Cell: gridProps =>
        GridContextMenu({ gridProps, options: this.menuOptions }),
    },
  ];

  componentDidMount() {
    const { getIPs, getEnabled } = this.props;

    getIPs();
    getEnabled();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      postIPResult,
      postIPErrors,
      clearPostIPResult,

      postDeleteIPResult,
      postDeleteIPErrors,
      clearPostDeleteIPResult,

      getMyIPResult,
      getMyIPErrors,
      clearGetMyIPResult,
      change,

      getMyIPValidResult,
      getMyIPValidErrors,
      clearGetValidateMyIPResult,

      setEnabledResult,
      setEnabledErrors,
      clearSetEnabledResult,
    } = this.props;

    if (postIPResult || postIPErrors) {
      if (!errorToast(this.props, prevProps, 'postIPErrors')) {
        NotificationMessage({ Data: postIPResult, Errors: [] });
        this.closeCreateModal();
      }

      clearPostIPResult();
    }

    if (postDeleteIPResult || postDeleteIPErrors) {
      if (!errorToast(this.props, prevProps, 'postDeleteIPErrors')) {
        NotificationMessage({ Data: postDeleteIPResult, Errors: [] });
        this.closeDeleteModal();
      }

      clearPostDeleteIPResult();
    }

    if (getMyIPResult || getMyIPErrors) {
      if (!errorToast(this.props, prevProps, 'getMyIPErrors')) {
        change(
          IPRANGE_ENTRY_FORM_NAME,
          IPRangeFieldEnum.LowerRange,
          getMyIPResult
        );
        change(IPRANGE_ENTRY_FORM_NAME, IPRangeFieldEnum.UpperRange, '');

        this.setState({ myIP: getMyIPResult });
      }

      clearGetMyIPResult();
    }

    if (getMyIPValidResult || getMyIPValidErrors) {
      if (!errorToast(this.props, prevProps, 'getMyIPValidErrors')) {
        this.openEnableModal();
      }

      clearGetValidateMyIPResult();
    }

    if (setEnabledResult || setEnabledErrors) {
      if (!errorToast(this.props, prevProps, 'setEnabledErrors')) {
        this.closeEnableModal();
      }

      clearSetEnabledResult();
    }
  }

  openCreateModal = (row = {}) => {
    this.setState({
      rowData: row,
      isCreateModalOpen: true,
    });
  };

  closeCreateModal = () => this.setState({ isCreateModalOpen: false });

  openDeleteModal = row => {
    if (!row) {
      return;
    }

    this.setState({
      rowData: row,
      isDeleteModalOpen: true,
    });
  };

  closeDeleteModal = () => this.setState({ isDeleteModalOpen: false });

  openEnableModal = () => this.setState({ isEnableModalOpen: true });
  closeEnableModal = () => this.setState({ isEnableModalOpen: false });

  /** submit a new row, and on success, add it to the table */
  handleSubmit = rowData => this.props.postIP(rowData);

  /** delete a row, and on success, delete it from the table */
  handleDelete = rowData =>
    this.props.postDeleteIP(rowData[IPRangeFieldEnum.Id]);

  /** fetch current ip if necessary and update form */
  handleMyIPRequest = () => {
    const { change, getMyIP } = this.props;
    const { myIP } = this.state;

    if (myIP) {
      change(IPRANGE_ENTRY_FORM_NAME, IPRangeFieldEnum.LowerRange, myIP);
      change(IPRANGE_ENTRY_FORM_NAME, IPRangeFieldEnum.UpperRange, '');

      return;
    }

    getMyIP();
  };

  /** toggle network filtering */
  handleFilteringChange = (confirmed = false) => {
    const { getEnabledResult, setEnabled, getValidateMyIP } = this.props;

    //if we're trying to turn it on, show a confirmation dialog first
    if (!getEnabledResult && !confirmed) {
      getValidateMyIP();
      return;
    }

    setEnabled(!getEnabledResult);
  };

  render() {
    const {
      rowData,
      isCreateModalOpen,
      isDeleteModalOpen,
      isEnableModalOpen,
    } = this.state;

    const {
      isReadOnly,
      getIPsResult,
      getIPsLoading,
      postIPLoading,
      getMyIPLoading,
      getEnabledResult,
      getEnabledLoading,
    } = this.props;

    return (
      <Fragment>
        <Filter title={'Network Filtering'}>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  label="Enable Network Filtering"
                  toggle
                  checked={getEnabledResult}
                  disabled={isReadOnly || getEnabledLoading}
                  onChange={() => this.handleFilteringChange()}
                />
              </Grid.Column>

              <Grid.Column floated="right" textAlign="right">
                <Button
                  content={`Add ${humanName}`}
                  onClick={() => this.openCreateModal()}
                  disabled={isReadOnly || getIPsLoading || postIPLoading}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>

        <Main>
          <ReactTable
            data={getIPsResult || []}
            className="-striped -highlight grid--fixed-row-height"
            loading={getIPsLoading}
            saveState={{ tableName: TableNamesEnum.NETWORKFILTERING_TABLE }}
            columns={this.columns}
            menu="hasCogs"
            pageSizeOptions={[5, 10, 15, 20, 25, 50, 100]}
            defaultPageSize={10}
            minRows={null}
            noDataText="No rows found"
          />

          <IPRangeEntryModal
            rowData={rowData}
            isOpen={isCreateModalOpen}
            onClose={this.closeCreateModal}
            onSubmit={this.handleSubmit}
            onMyIPRequest={this.handleMyIPRequest}
            myIPDisabled={getMyIPLoading}
          />

          <YesNoDialog
            showDialog={isDeleteModalOpen}
            title={`Delete ${humanName}`}
            question={`Are you sure you want to delete this ${humanName}: ${(rowData &&
              rowData[IPRangeFieldEnum.Description]) ||
              rangeString(rowData)}?`}
            yesCallback={() => this.handleDelete(rowData)}
            noCallback={() => this.closeDeleteModal()}
          />

          <YesNoDialog
            showDialog={isEnableModalOpen}
            title={`Enable Network Filtering`}
            question={`Are you sure you want to enable network filtering?`}
            yesCallback={() => this.handleFilteringChange(true)}
            noCallback={() => this.closeEnableModal()}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    getIPsLoading: NetworkFilteringSelectors.getIPsLoading(state),
    getIPsResult: NetworkFilteringSelectors.getIPsResult(state),

    getEnabledLoading: NetworkFilteringSelectors.getEnabledLoading(state),
    getEnabledResult: NetworkFilteringSelectors.getEnabledResult(state),

    setEnabledLoading: NetworkFilteringSelectors.setEnabledLoading(state),
    setEnabledResult: NetworkFilteringSelectors.setEnabledResult(state),
    setEnabledErrors: NetworkFilteringSelectors.setEnabledErrors(state),

    postIPLoading: NetworkFilteringSelectors.postIPLoading(state),
    postIPResult: NetworkFilteringSelectors.postIPResult(state),
    postIPErrors: NetworkFilteringSelectors.postIPErrors(state),

    getMyIPLoading: NetworkFilteringSelectors.getMyIPLoading(state),
    getMyIPResult: NetworkFilteringSelectors.getMyIPResult(state),
    getMyIPErrors: NetworkFilteringSelectors.getMyIPErrors(state),

    postDeleteIPLoading: NetworkFilteringSelectors.postDeleteIPLoading(state),
    postDeleteIPResult: NetworkFilteringSelectors.postDeleteIPResult(state),
    postDeleteIPErrors: NetworkFilteringSelectors.postDeleteIPErrors(state),

    getMyIPValidLoading: NetworkFilteringSelectors.getMyIPValidLoading(state),
    getMyIPValidResult: NetworkFilteringSelectors.getMyIPValidResult(state),
    getMyIPValidErrors: NetworkFilteringSelectors.getMyIPValidErrors(state),
  };
};

const mapDispatchToProps = {
  getIPs: NetworkFilteringActions.getIPs,

  getEnabled: NetworkFilteringActions.getEnabled,

  setEnabled: NetworkFilteringActions.setEnabled,
  clearSetEnabledResult: NetworkFilteringActions.clearSetEnabledResult,

  postIP: NetworkFilteringActions.postIP,
  clearPostIPResult: NetworkFilteringActions.clearPostIPResult,

  getMyIP: NetworkFilteringActions.getMyIP,
  clearGetMyIPResult: NetworkFilteringActions.clearGetMyIPResult,

  postDeleteIP: NetworkFilteringActions.postDeleteIP,
  clearPostDeleteIPResult: NetworkFilteringActions.clearPostDeleteIPResult,

  getValidateMyIP: NetworkFilteringActions.getValidateMyIP,
  clearGetValidateMyIPResult:
    NetworkFilteringActions.clearGetValidateMyIPResult,

  change,
};

export const NetworkFiltering = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(NetworkFilteringContainer)
);



// WEBPACK FOOTER //
// ./src/pages/networkfiltering/NetworkFiltering.js